/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Button, Modal } from 'antd';
import { useGenerationDataStore } from '@core/hooks';
import { ArrowLeftOutlined, LoadingOutlined } from '@ant-design/icons';
import { useBreakpoint } from '@core/hooks/useBreakpoint';
import { MIDDLE_STYLE } from '@constants/responsive';
import { GLOBAL_THEME_COLOR } from '@constants/theme';
import { AutoReviewGeneratorEngineStatus } from '@core/models';
import { BRAND_LOGO_CONSTRAST, BRAND_NAME } from '@constants/brand';
import { useHistory } from 'react-router';

type Props = {};

const AutoReviewGenerateStatusOverlay = (props: Props) => {
  const { isTablet } = useBreakpoint();
  const history = useHistory();
  const { autoReviewEngineStatus } = useGenerationDataStore();

  return (
    <Modal
      width={'100%'}
      className="snap-action-modal"
      footer={[]}
      maskStyle={{
        backdropFilter:
          autoReviewEngineStatus === AutoReviewGeneratorEngineStatus.NotEnoughDataNotify
            ? 'blur(50px)'
            : 'blur(10px)',
      }}
      closeIcon={<></>}
      open={
        autoReviewEngineStatus !== AutoReviewGeneratorEngineStatus.NotStarted &&
        autoReviewEngineStatus !== AutoReviewGeneratorEngineStatus.Finished
      }>
      <div style={{ ...MIDDLE_STYLE, flexDirection: 'column' }}>
        <div style={{ fontSize: 150 }}>
          {autoReviewEngineStatus === AutoReviewGeneratorEngineStatus.NotEnoughDataNotify && '😥'}
          {autoReviewEngineStatus === AutoReviewGeneratorEngineStatus.CollectBusinessReviews &&
            '🤩'}
          {autoReviewEngineStatus === AutoReviewGeneratorEngineStatus.GenerateReviewResponse &&
            '💬'}
          {autoReviewEngineStatus === AutoReviewGeneratorEngineStatus.Running && (
            <img src={BRAND_LOGO_CONSTRAST} alt={BRAND_NAME} style={{ width: 150 }} />
          )}
        </div>
        <h2
          style={{
            fontSize: isTablet ? 25 : 50,
            margin: 0,
            color: GLOBAL_THEME_COLOR.$text_color_contrast,
          }}>
          {autoReviewEngineStatus !== AutoReviewGeneratorEngineStatus.NotEnoughDataNotify && (
            <LoadingOutlined style={{ marginRight: 20 }} />
          )}
          {autoReviewEngineStatus === AutoReviewGeneratorEngineStatus.CollectBusinessReviews &&
            'Collecting business reviews'}
          {autoReviewEngineStatus === AutoReviewGeneratorEngineStatus.GenerateReviewResponse &&
            'Replying to business reviews'}
          {autoReviewEngineStatus === AutoReviewGeneratorEngineStatus.Running &&
            'Gathering business information'}
          {autoReviewEngineStatus === AutoReviewGeneratorEngineStatus.NotEnoughDataNotify &&
            'Not Enough Business Data'}
        </h2>
        <p
          style={{
            fontSize: isTablet ? 15 : 20,
            textAlign: 'center',
            margin: 0,
            color: GLOBAL_THEME_COLOR.$text_color_contrast,
          }}>
          {autoReviewEngineStatus === AutoReviewGeneratorEngineStatus.CollectBusinessReviews &&
            'Amazely is collecting reviews of your business...'}
          {autoReviewEngineStatus === AutoReviewGeneratorEngineStatus.Running &&
            'Amazely is gathering your business information...'}
          {autoReviewEngineStatus === AutoReviewGeneratorEngineStatus.GenerateReviewResponse &&
            'Amazly is answering the recent reviews of the business...'}
          {autoReviewEngineStatus === AutoReviewGeneratorEngineStatus.NotEnoughDataNotify &&
            'Select another Google business for demo or sign in the app to start collecting reviews.'}
        </p>
        {autoReviewEngineStatus === AutoReviewGeneratorEngineStatus.NotEnoughDataNotify && (
          <Button
            style={{
              cursor: 'pointer',
              padding: 24,
              borderRadius: 50,
              marginTop: 50,
              ...MIDDLE_STYLE,
            }}
            size="large"
            type="primary"
            onClick={() => history.goBack()}>
            <ArrowLeftOutlined /> Select Another Business for Demo
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default AutoReviewGenerateStatusOverlay;
